import React from 'react';
import { Table, Popconfirm, Form, Typography, message, ConfigProvider, Input, InputNumber, Select, DatePicker } from 'antd';
import axios from '../../../utils/AxiosUtil';
import { axiosPostAndHint } from '../../../components/reqAndHint'
import AsyncSwitch from '../../../components/AsycSwitch'
import 'moment/locale/zh-cn';
// import locale from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import { useSelector } from 'react-redux'

const { useState, useEffect } = React;
var date2Str = require('../../../utils/date2Str');
const { Option } = Select;


/**
 * 可编辑表格
 * @param props{
 *    columns：表头 参见antd table组件
 *    dataSource：每一行的数据 参见antd table组件
 * }
 */

const EditableCell = ({
    editing,
    dataIndex,
    title,
    rules,
    record,
    index,
    children,
    ...restProps
}) => {
    const langValue = useSelector(state => state.langList.value)
    let inputNode;
    switch (dataIndex) {
        case '权限':
            inputNode = (<Form.Item
                name={dataIndex}
                style={{ margin: 0 }}
            >
                <Select
                // defaultValue='通用'
                >
                    <Option value="通用" key="on">{langValue == 0 ? '通用General' : (langValue == 1 ? '通用' : 'General')}</Option>
                    <Option value="不通用" key="off">{langValue == 0 ? '不通用Not general' : (langValue == 1 ? '不通用' : 'Not general')}</Option>
                </Select>
            </Form.Item>
            );
            break;
        case '停用日期':
            inputNode = (<Form.Item
                name={dataIndex}
                rules={[{ required: true, message: '请选择日期' }]}
                style={{ margin: 0 }}
            >
                <DatePicker

                    placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                    format="YYYY-MM-DD"
                // defaultValue={moment(record.停用日期, 'YYYY-MM-DD')}
                />
            </Form.Item>)
            break;
        case '状态':
            inputNode = (<Form.Item
                name={dataIndex}
                style={{ margin: 0 }}
            >
                <Select
                // defaultValue='on'
                >
                    <Option value="on" key="on">{langValue == 0 ? '启用Active' : (langValue == 1 ? '启用' : 'Active')}</Option>
                    <Option value="off" key="off">{langValue == 0 ? '停用Inactive' : (langValue == 1 ? '停用' : 'Inactive')}</Option>
                </Select>
            </Form.Item>)
            break;
        default:
            inputNode = (<Form.Item
                name={dataIndex}
                style={{ margin: 0 }}
                rules={rules ? [...rules] : null}
            >
                <Input />
            </Form.Item>);
            break;
    }

    return (
        <td {...restProps}>
            {editing ? (
                inputNode
            ) : (
                    children
                )}
        </td>
    );
};


const EditableTable = (props) => {
    const langValue = useSelector(state => state.langList.value)
    let originData = props.dataSource;
    // console.log('originData:', originData);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);

    //需要编辑的record的project_id
    const [editingKey, setEditingKey] = useState('');

    useEffect(() => {
        setData([...originData])
    }, [props])

    //暂存正在编辑的行
    const isEditing = (record) => record.project_id === editingKey;

    //点击编辑按钮
    const edit = (record) => {
        // console.log("on edit:", record);
        //改日期格式
        record.停用日期 = moment(record.停用日期, 'YYYY-MM-DD');
        form.setFieldsValue({
            ...record,
        });
        // console.log("停用日期:", record.停用日期);
        //record的key字段,将该行定位成编辑状态
        setEditingKey(record.project_id);
    };

    const cancel = (record) => {
        // console.log("on cancel:", record);
        // console.log("type:", typeof record);
        //改日期格式
        if (typeof record == 'object') {
            record.停用日期 = date2Str.format(record.停用日期, 'yyyy-MM-dd');
            // console.log("停用日期:", record.停用日期);
        }
        setEditingKey('');
    };

    const save = async (project_id) => {
        // console.log("on save");
        try {
            const row = await form.validateFields();
            row.donationItem = row.捐款项目;
            row.permission = row.权限;
            row.deadline = row.停用日期;
            row.projectStatus = row.状态;
            row.projectId = editingKey;
            row.deadline = date2Str.format(row.deadline, 'yyyy-MM-dd');
            // console.log('row', row);

            axiosPostAndHint('/project/update', row,
                () => {
                    const newData = [...data];
                    //查找在编辑的那一行
                    const index = newData.findIndex((item) => project_id === item.project_id);
                    //改变日期格式
                    row.停用日期 = date2Str.format(row.deadline, 'yyyy-MM-dd');
                    //有则更新，无则新增
                    if (index > -1) {
                        const item = newData[index];
                        newData.splice(index, 1, { ...item, ...row });
                        setData(newData);
                        // console.log('index>-1:', index)
                        // console.log('newData:', newData)
                        setEditingKey('');
                    } else {
                        newData.push(row);
                        setData(newData);
                        // console.log('index else:', index)
                        // console.log('newData:', newData)
                        setEditingKey('');
                    }
                },
                () => {
                    //更新失败时，将日期格式改为string
                    data.forEach((e) => {
                        e.停用日期 = date2Str.format(e.停用日期, 'yyyy-MM-dd')
                    })
                    // console.log('data:', data)
                    setEditingKey('');
                });

        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    let columns = [...props.columns];
    columns.push({
        title: '操作',
        en_title: 'operation',
        ch_title: '操作',
        dataIndex: 'operation',
        render: (_, record) => {
            const editable = isEditing(record);
            return editable ? (
                <span>
                    <Typography.Link
                        onClick={() => save(record.project_id)}
                        style={{
                            marginRight: 8,
                        }}
                    >
                        {langValue == 0 ? '保存Save' : (langValue == 1 ? '保存' : 'Save')}
                    </Typography.Link>
                    {/* <Popconfirm title="确定撤销更改?" onConfirm={() => cancel(record)}> */}
                    <a onClick={() => cancel(record)}>{langValue == 0 ? <><br />撤销Cancle</> : (langValue == 1 ? '撤销' : 'Cancle')}</a>
                    {/* </Popconfirm> */}
                </span>
            ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        {langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}
                    </Typography.Link>
                );
        },
    })
    columns[1].render = (_, item2) => {
        // return langValue == 0 ? <span>{item2['捐款项目']}<br />{item2.en_proj}</span> : (langValue == 1 ? item2['捐款项目'] : item2.en_proj)
        return item2['捐款项目'];// 显示中文（实际双语）
    }
    //状态用开关组件渲染
    columns[4].render = (text, record, index) => {
        let checked = record['状态'] == 'on';
        let rcd = record;

        //和组件在同一上下文
        function handleSwitchClick(checked, record) {
            return new Promise((resolve, reject) => {
                axios.post('/fund/project/updateStatus', { projectId: record['project_id'], projectStatus: checked ? "on" : "off" })
                    .then((data) => {
                        // console.log('*********axios data:', data);
                        record['状态'] = checked ? "on" : "off";
                        message.destroy();
                        message.info("更新项目状态成功");
                        resolve(checked);
                    }).catch(e => {
                        //组件应及时恢复原状态,和成功相反，逆向操作
                        //
                        // console.log('*********axios e:', e, e.response.data);
                        record['状态'] = !checked ? "on" : "off"; "on";
                        message.destroy();
                        message.error("更新地区状态失败：" + e ?.response ?.data ?.msg);
                        reject(!checked);
                    });
            })
        }

        return (<div>
            <AsyncSwitch checked={checked} handleClick={
                (checked) => handleSwitchClick(checked, rcd)
            } />
        </div>);
    }


    const mergedColumns = columns.map((col) => {
        col.title = langValue == 0 ? <>{col.ch_title}<br />{col.en_title}</> : (langValue == 1 ? col.ch_title : col.en_title)
        if (!col.editable) {
            // console.log(col.title, " not editable")
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,//每个单元格对应的行record
                rules: col.rules,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });


    return (
        <ConfigProvider>
            <Form
                form={form}
                component={false}
            >
                <Table
                    sticky
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        pageSizeOptions: [10, 20, 50, 100, 1000, 10000],
                        onChange: cancel,
                        showQuickJumper: true,
                    }}
                    rowKey={'序号'}
                />
            </Form>
        </ConfigProvider>
    );
};

export default EditableTable;
